
const state = {
  code: [],
  cursor: 0
}

const getters = {
  currentCode: state => {
    return state.code.slice(0, state.cursor)
  },
  sliceCode: state => index => {
    return state.code.slice(index, state.cursor)
  }
}

const mutations = {
  SET_CODE (state, data) {
    state.code = data
    state.cursor = 0
  },
  NEXT_CODE (state) {
    if(state.cursor < state.code.length){
      state.cursor += 1
    }
  },
  SKIP_CODE (state) {
    state.cursor = state.code.length
  }
}

const actions = {
  setCode({ commit }, data) {
    commit('SET_CODE', data)
  },
  nextCode({ commit }) {
    commit('NEXT_CODE')
  },
  skipCode({ commit }) {
    commit('SKIP_CODE')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
